import {Box, Code} from "@mantine/core";
import {PropsWithChildren} from 'react';

export function PlainTextCodeBox(props: PropsWithChildren) {
    const highlightTOML = (text: string) => {
        const sectionPattern = /^\[(.*?)\]$/;               // Matches sections like [section]
        const keyValuePattern = /^([-]*\w+)\s*=\s*(.+)$/;   // Matches keys with or without dashes
        const stringPattern = /(".*?"|'.*?')/g;             // Matches strings within quotes
        const numberPattern = /\b\d+(_\d+)*\b/g;            // Matches numbers (with or without underscores)
        const booleanPattern = /\b(true|false)\b/gi;        // Matches booleans true/false

        return text.split('\n').map((line, index) => {
            // Check if the line is a section
            if (sectionPattern.test(line)) {
                const section = line.match(sectionPattern);
                return (
                    <div key={index} style={{ color: '#4EA8FF', marginBottom: '0.5rem' }}>
                        [{section![1]}]
                    </div>
                );
            }

            // Check if the line is a key-value pair
            const keyValueMatch = line.match(keyValuePattern);
            if (keyValueMatch) {
                const key = keyValueMatch[1];
                let value = keyValueMatch[2];

                // Highlight value based on type
                if (stringPattern.test(value)) {
                    value = value.replace(stringPattern, (str) => `<span style="color: #BD93F9;">${str}</span>`);
                } else if (numberPattern.test(value)) {
                    value = value.replace(numberPattern, (num) => `<span style="color: #FFADC6;">${num}</span>`);
                } else if (booleanPattern.test(value)) {
                    value = value.replace(booleanPattern, (bool) => `<span style="color: #9A79E6;">${bool}</span>`);
                }

                return (
                    <div key={index} style={{ marginBottom: '0.5rem' }}>
                        <span style={{ color: '#FF6FCF' }}>{key}</span> ={' '}
                        <span dangerouslySetInnerHTML={{ __html: value }} />
                    </div>
                );
            }

            // If it's a plain line without any special format, add a small margin for consistent spacing
            return <div key={index} style={{ marginBottom: '0.5rem' }}>{line}</div>;
        });
    };

    return (
        <Box
            bg="#0A1C22"
            style={{
                '--radius': '0.2rem',
                borderRadius: '10px',
                padding: '0.5rem 1rem', // Adjust padding for balanced spacing
                width: '1000px'
            }}
        >
            <Code
                block
                bg="#0A1C22"
                color="#0A1C22"
                c="white"
                style={{whiteSpace: 'pre-wrap', fontSize: '1rem'}}
            >
                {highlightTOML(props.children as string)}
            </Code>
        </Box>
    );
}
